module.exports = __webpack_public_path__ + "img/reward-points-icon.5cc65db7.svg";